<template>
  <el-tabs v-model="active" type="border-card">
    <el-tab-pane label="待结算" name="N" lazy>
      <PageTableWait />
    </el-tab-pane>
    <el-tab-pane label="已结算" name="Y" lazy>
      <PageTableAlready />
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import PageTableWait from './components/tableWait'
import PageTableAlready from './components/tableAlready'
export default {
  name: 'finance-accountingBookOfWaybill',
  components: { PageTableAlready, PageTableWait },
  data() {
    return { active: 'N' }
  },
}
</script>
